import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { channelList } from '@/utils/constant'
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Table,
    message,
    Row,
    Col,
    Card,
    Select,
    DatePicker,
    Button,
    InputNumber,
    Pagination,
    Input,
    Spin,
    Tag,
} from "antd";

export default class CodeSendRecord extends React.Component {
    state = {
        loading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            uid: undefined,
            phone: undefined,
            email: undefined,
            date: [],
        },
        data: [], // 表格数据
        channelList: [], // 渠道列表,
    };

    componentDidMount () {
        this.fetchData();
        this.fetchChannelList()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/union_user_vercode_list", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取渠道列表
     */
    fetchChannelList = () => {
        axios
            .get('/v1/api/support/channel_list')
            .then((res) => {
                this.setState({
                    channelList: res.data || []
                })
            })
    };

    /**
     * 改变数据分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    uid: undefined,
                    phone: undefined,
                    email: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["playerIdPlaceholder"]}
                        value={this.state.queryParams.uid}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("uid", value)
                        }
                    />
                    <Input
                        maxLength={60}
                        allowClear
                        placeholder={this.props.language["phoneAccountPlaceholder"]}
                        value={this.state.queryParams.phone}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("phone", e.target.value)
                        }
                    />
                    <Input
                        maxLength={60}
                        allowClear
                        placeholder={this.props.language["emailAccountPlaceholder"]}
                        value={this.state.queryParams.email}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("email", e.target.value)
                        }
                    />
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["registerChannelPlaceholder"]}
                        value={this.state.queryParams.register_channel}
                        onChange={(value) => this.handleSetQueryParamsData("register_channel", value)}
                    >
                        {this.state.channelList.map((item, index) => (
                            <Select.Option value={item.id} key={index}>
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="created_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex=""
                            render={(item) =>
                                item.status === 1 ?
                                    <Tag color="green">{this.props.language["succeed"]}</Tag>
                                    :
                                    <Tag color="red">{this.props.language["failed"]}</Tag>
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["registerChannel"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.channelList.find(
                                    (item2) => item2.id === item.register_channel
                                )
                                    ? this.state.channelList.find(
                                        (item2) => item2.id === item.register_channel
                                    ).name
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerId"]}
                            dataIndex="uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerName"]}
                            dataIndex="name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["verificationCodeSource"]}
                            dataIndex="code_func"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["verificationCode"]}
                            dataIndex="code"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["emailAccount"]}
                            dataIndex="email"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["areaCode"]}
                            dataIndex="area"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["phoneAccount"]}
                            dataIndex="phone"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["overheadInformation"]}
                            dataIndex="return_msg"
                        />
                    </Table>
                    <Pagination
                        className="pagination"
                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>
            </div>
        );
    }
}